<template>
    <a-result status="404" title="Lỗi 404" sub-title="Trang này không tồn tại">
        <template #extra>
            <router-link :to="{ name: RouteName.TOP }">
                <a-button type="primary">Về trang chủ</a-button>
            </router-link>
        </template>
    </a-result>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import {
    Result, Button,
} from 'ant-design-vue'

import { RouteName } from '@/router'

export default defineComponent({
    components: {
        AResult: Result,
        AButton: Button,
    },
    setup() {
        return {
            RouteName,
        };
    },
})
</script>

